import { IdCard } from 'lucide-react';
import { nomeCadastro, nomePessoa } from '../../nucleo/formato';
import { moduloWeb, type FonteBuscaGlobal } from '../../nucleo/modulos-web';

/**
 * Lista de 30/10 (item 10): funcionários na busca da barra superior. A busca do servidor é a da lista (nome, e-mail; CPF e
 * telefone só para quem tem `pessoas.confidencial`). Abre a ficha do funcionário.
 */
interface FuncionarioBusca {
  id: string;
  nome: string;
  funcao_nome: string | null;
  departamento_nome: string | null;
}

export const buscaPessoas: FonteBuscaGlobal[] = [
  {
    chave: 'funcionarios',
    permissao: 'pessoas.ver',
    pagina: 'pessoas.funcionarios',
    grupo: 'buscaGlobal.funcionarios',
    posicao: 60,
    icone: IdCard,
    item: (f: FuncionarioBusca) => ({
      id: f.id,
      rotulo: nomePessoa(f.nome),
      detalhe: [nomeCadastro(f.funcao_nome), nomeCadastro(f.departamento_nome)].filter(Boolean).join(' · ') || undefined,
      link: `/${moduloWeb('pessoas')?.menu ?? 'pessoas'}/pessoas/funcionario/${f.id}`,
    }),
  },
];
